import { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight, BookOpen } from "lucide-react";
import { fileUrl } from "../lib/api";

export function LookInside({ product }) {
  const pages = product.preview_keys || [];
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); if (e.key === "ArrowRight") setI((x) => Math.min(x + 1, pages.length - 1)); if (e.key === "ArrowLeft") setI((x) => Math.max(x - 1, 0)); };
    window.addEventListener("keydown", onKey); return () => window.removeEventListener("keydown", onKey);
  }, [open, pages.length]);
  if (pages.length === 0) return null;

  return (
    <>
      <button data-testid="look-inside-btn" onClick={() => { setI(0); setOpen(true); }} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#0a192f] hover:text-[#d4af37] border border-[#0a192f] px-4 py-2 transition-colors">
        <BookOpen className="w-4 h-4" /> Look inside · {pages.length} sample page{pages.length > 1 ? "s" : ""}
      </button>
      {open && (
        <div data-testid="look-inside-modal" className="fixed inset-0 z-50 bg-[#0a192f]/95 flex flex-col" onClick={() => setOpen(false)}>
          <div className="flex items-center justify-between px-6 py-4 text-white" onClick={(e) => e.stopPropagation()}>
            <div><div className="overline text-[#d4af37]">Look inside</div><div className="font-serif text-xl">{product.name}</div></div>
            <div className="flex items-center gap-4">
              <span data-testid="look-inside-counter" className="text-sm tracking-widest">{i + 1} / {pages.length}</span>
              <button data-testid="look-inside-close" onClick={() => setOpen(false)} aria-label="Close" className="w-10 h-10 flex items-center justify-center hover:bg-white/10"><X /></button>
            </div>
          </div>
          <div className="flex-1 flex items-center justify-center gap-4 px-4 pb-6 min-h-0" onClick={(e) => e.stopPropagation()}>
            <button data-testid="look-inside-prev" disabled={i === 0} onClick={() => setI(i - 1)} className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-white/10 text-white hover:bg-[#d4af37] hover:text-[#0a192f] disabled:opacity-20 transition-colors"><ChevronLeft /></button>
            <img key={pages[i]} data-testid="look-inside-page" src={fileUrl(pages[i])} alt={`${product.name} sample page ${i + 1}`} className="max-h-full max-w-[min(90vw,900px)] object-contain shadow-2xl bg-white animate-[fadeIn_.3s_ease]" />
            <button data-testid="look-inside-next" disabled={i === pages.length - 1} onClick={() => setI(i + 1)} className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-white/10 text-white hover:bg-[#d4af37] hover:text-[#0a192f] disabled:opacity-20 transition-colors"><ChevronRight /></button>
          </div>
          <div className="flex justify-center gap-2 pb-6" onClick={(e) => e.stopPropagation()}>
            {pages.map((k, idx) => <button key={k} data-testid={`look-inside-dot-${idx}`} onClick={() => setI(idx)} className={`w-2.5 h-2.5 ${idx === i ? "bg-[#d4af37]" : "bg-white/30 hover:bg-white/60"}`} aria-label={`Page ${idx + 1}`} />)}
          </div>
        </div>
      )}
    </>
  );
}
